import { useMemo } from "react";
import axios from "axios";
import { getInvoiceColumns } from "../components/Order/invoiceColumns";
import { API_BASE_URL } from '../api';
import useRangeMax from "./useRangeMax";

export default function useInvoiceColumns({
    setPdfData,
    setShowPdfModal,
    setPageNumber,
    setEmailTarget,
    excludeColumns = []
}) {
    const totalMax = useRangeMax(`${API_BASE_URL}/api/v1/invoices`, "totalAmount");

    return useMemo(() => {
        const printReceipt = (id) => {
            axios.get(`${API_BASE_URL}/api/v1/invoice/${id}/receipt`, {
                withCredentials: true,
                responseType: "blob",
            }).then((response) => {
                const url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                const win = window.open(url, '_blank');
                if (win) {
                    win.addEventListener('load', () => {
                        setTimeout(() => { win.print(); }, 500);
                    });
                }
            }).catch(console.error);
        };

        const handleViewPdf = (id) => {
            axios.get(`${API_BASE_URL}/api/v1/invoice/${id}/download`, {
                withCredentials: true,
                responseType: "blob",
            })
                .then((response) => {
                    const file = new Blob([response.data], {
                        type: "application/pdf",
                    });

                    const fileURL = URL.createObjectURL(file);

                    setPdfData(fileURL);
                    setShowPdfModal(true);
                    setPageNumber(1);
                })
                .catch((error) => {
                    console.error("Erreur PDF :", error);
                });
        };

        const downloadInvoice = (id) => {
            axios.get(`${API_BASE_URL}/api/v1/invoice/${id}/download`, {
                withCredentials: true,
                responseType: "blob",
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data], {
                            type: "application/pdf",
                        })
                    );

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `invoice-${id}.pdf`;
                    link.click();

                    URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(error);
                });
        };

        const openSendEmail = (row) => setEmailTarget(row);

        let cols = getInvoiceColumns({
            handleViewPdf,
            downloadInvoice,
            printReceipt,
            openSendEmail,
            totalMax,
        });

        if (excludeColumns.length > 0) {
            cols = cols.filter(col => !excludeColumns.includes(col.accessor));
        }

        return cols;
    }, [setPdfData, setShowPdfModal, setPageNumber, setEmailTarget, excludeColumns, totalMax]);
}